module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_a-15892c9f2991783b4e88e005499dbd45.png";